"use client";

import {
  Toaster as ChakraToaster,
  Flex,
  IconButton,
  Portal,
  Spinner,
  Stack,
  Toast,
  createToaster,
} from "@chakra-ui/react";
import { FaTimes } from "react-icons/fa";
import {
  ToastErrorIcon,
  ToastInfoIcon,
  ToastSuccessIcon,
  ToastWarningIcon,
} from "@/components/Icons";

export const toaster = createToaster({
  placement: "top-end",
  pauseOnPageIdle: true,
  offsets: "20px",
});

const TOAST_THEME = {
  error: { bg: "errorLight.500", accent: "error.500", Icon: ToastErrorIcon },
  success: { bg: "successLight.500", accent: "success.500", Icon: ToastSuccessIcon },
  warning: { bg: "warningLight.500", accent: "warning.500", Icon: ToastWarningIcon },
  info: { bg: "infoLight.500", accent: "info.500", Icon: ToastInfoIcon },
};

export const Toaster = () => {
  return (
    <Portal>
      <ChakraToaster toaster={toaster} insetInline={{ mdDown: "4" }}>
        {(toast) => {
          if (toast.type === "loading") {
            return (
              <Toast.Root width={{ md: "sm" }}>
                <Spinner size="sm" color="blue.solid" />
                <Stack gap="1" flex="1" maxWidth="100%">
                  {toast.title && <Toast.Title fontSize="lg">{toast.title}</Toast.Title>}
                  {toast.description && <Toast.Description>{toast.description}</Toast.Description>}
                </Stack>
              </Toast.Root>
            );
          }

          const theme = TOAST_THEME[toast.type] || TOAST_THEME.info;
          const { Icon } = theme;

          return (
            <Toast.Root
              p="0"
              bg={theme.bg}
              borderRadius="md"
              overflow="hidden"
              width={{ base: "full", md: "464px" }}
              boxShadow="md"
              border="none"
            >
              <Flex w="full" align="stretch">
                <Flex bg={theme.accent} w="64px" align="center" justify="center" flexShrink={0}>
                  <Icon color="white" boxSize="32px" />
                </Flex>
                <Flex flex="1" pl="24px" pr="16px" py="20px" align="flex-start" gap="2">
                  <Stack gap="1" flex="1" maxW="100%">
                    {toast.title && (
                      <Toast.Title color="textBlack.800" fontWeight="bold" fontSize="lg">
                        {toast.title}
                      </Toast.Title>
                    )}
                    {toast.description && (
                      <Toast.Description color="textBlack.800">
                        {toast.description}
                      </Toast.Description>
                    )}
                  </Stack>
                  <Toast.CloseTrigger asChild>
                    <IconButton
                      aria-label="Close"
                      size="xs"
                      variant="ghost"
                      color="textBlack.800"
                      position="static"
                      _hover={{
                        bg: "transparent",
                        opacity: 0.6,
                      }}
                    >
                      <FaTimes />
                    </IconButton>
                  </Toast.CloseTrigger>
                </Flex>
              </Flex>
            </Toast.Root>
          );
        }}
      </ChakraToaster>
    </Portal>
  );
};
